import React, { useCallback } from 'react';
import { useStateRef } from '@op/hooks/common';
import RegionCountryItem from '@op/components/Snippets/RegionCountryItem';
import { RadioAllMultipleSelect } from '@opm/components/FilterCommon/components/RadioAllMultipleSelect';
import { allCountryMap } from '@opm/components/FilterCommon/constants/country';
import { TOptionsItem } from '@opm/components/FilterCommon/types';
import useIntls from '@opm/hooks/useIntls';
import { getNextActiveQuickKeys } from './subFilterUtils';
import { QUICK_REGION_OPTIONS, TCountryMode, X_HASHTAG_COND_SOURCE } from './constants';

export interface IXCountryFilterProps {
  countryMode: TCountryMode;
  activeQuickKeys: string[];
  customCountries: string[];
  countryOptions: TOptionsItem[];
  onQuickSelect: (activeQuickKeys: string[]) => void;
  onCustomOpen: () => void;
  onCustomCommit: (countries: string[]) => void;
}

export default function XCountryFilter({
  countryMode,
  activeQuickKeys,
  customCountries,
  countryOptions,
  onQuickSelect,
  onCustomOpen,
  onCustomCommit,
}: IXCountryFilterProps) {
  const { intl } = useIntls();
  const [draftRef, draftCountries, setDraftCountries] = useStateRef<string[]>(
    customCountries,
  );

  const handleQuickClick = useCallback(
    (key: string) => {
      onQuickSelect(getNextActiveQuickKeys(countryMode, activeQuickKeys, key));
    },
    [countryMode, activeQuickKeys, onQuickSelect],
  );

  const handleOpen = useCallback(() => {
    setDraftCountries(customCountries);
    onCustomOpen();
  }, [customCountries, onCustomOpen, setDraftCountries]);

  const handleClose = useCallback(() => {
    onCustomCommit(draftRef.current ?? []);
  }, [draftRef, onCustomCommit]);

  const renderCountryItem = useCallback((option: TOptionsItem) => {
    return (
      <RegionCountryItem
        iconStyle={{ width: 16 }}
        market={option.value}
      />
    );
  }, []);

  return (
    <div className="dbom-x-hashtag-country-filter">
      <div className="dbom-x-hashtag-quick-options">
        {QUICK_REGION_OPTIONS.map((option) => (
          <span
            key={option.key}
            className={`dbom-x-hashtag-quick-btn  ${countryMode === 'quick' && activeQuickKeys.includes(option.key) ? 'is-active' : ''}  `}
            onClick={() => handleQuickClick(option.key)}
          >
            {intl(option.label)}
          </span>
        ))}
        <div className={`dbom-x-hashtag-country-custom-select ${countryMode === 'custom' ? 'is-active' : ''}`}  >
          <RadioAllMultipleSelect
            {...allCountryMap}
            title="Customize"
            titleCn="自定义"
            valueKeys="countries"
            leftText="Country"
            options={countryOptions}
            value={draftCountries ?? []}
            change={setDraftCountries}
            onOpen={handleOpen}
            onClose={handleClose}
            filterValue={{ source: X_HASHTAG_COND_SOURCE }}
            hasSelectAllBtn
            itemRender={renderCountryItem}
            overlayClassName={'dbom-x-hashtag-country-custom-select-overlay'}
          />
        </div>
      </div>
    </div>
  );
}
